import * as React from 'react';
import Grid from '@material-ui/core/Grid';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Radio from '@material-ui/core/Radio';

import { BaseComponent, IStateBase } from 'components/BaseComponent';
import { shippingService } from 'services/ShippingService';
import { IShippingData, IShipping } from 'interfaces/IProductData';
import { CurrencyFormat } from 'components/CurrencyFormat';
import Translate from 'components/Translate';
import { cartService } from 'services/CartService';

const styles = require('./styles.css');

interface IState extends IStateBase {
  selected: string;
  model: IShippingData;
}

export default class ShippingForm extends BaseComponent<IState> {

  constructor(props: any) {
    super(props);
  }

  componentDidMount() {
    shippingService.getShipping()
      .filter(data => data.shippingItems.length > 0)
      .distinctUntilChanged((a, b) => JSON.stringify(a) === JSON.stringify(b))
      .bindComponent(this)
      .subscribe(model => {
        this.setModel(model);
        this.setState({ selected: model.shippingItems[0].code });
      });
  }

  handleChange = (event: any) => {
    const selectedShipping = this.state.model.shippingItems
      .find((data: IShipping) => data.code === event.target.value);
    this.setState({ selected: selectedShipping.code });

    cartService.setShipping(this.state.model.hash, selectedShipping);
  }

  render() {
    if (!this.state) {
      return <div />;
    }
    const { shippingItems } = this.state.model;

    return (
      <div className={styles.component}>
        <Grid container spacing={24}>
          <Grid item xs={12}>
            <div className='chk-form-shipping'>
              <RadioGroup
                id='radioGroup'
                aria-label='shipping'
                name='shipping'
                value={this.state.selected}
                onChange={this.handleChange}
              >
                {shippingItems.map(method =>
                  <FormControlLabel
                    key={method.code}
                    value={method.code}
                    control={<Radio checked={this.state.selected == method.code ? true : false} id={`shipping-radio-${method.code}`} />}
                    classes={{
                      root: 'chk-shipping-form-control-root',
                      label: 'chk-shipping-form-control'
                    }}
                    label={
                      <Grid container spacing={8}>
                        <Grid item xs={4}>{method.title}</Grid>
                        <Grid item xs={4}><CurrencyFormat value={method.value} /></Grid>
                        <Grid item xs={4} className='right'>{method.deadline}&nbsp;
                          {method.deadline === 1 ?
                            <Translate term='dia' /> :
                            <Translate term='dias' />}
                        </Grid>
                      </Grid>}
                  />
                )}
              </RadioGroup>
            </div>
          </Grid>
        </Grid>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/Cart/Physical/ShippingForm/index.tsx